import React from 'react'
import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core'

function LikersList({ list, open, handleClose }) {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle>
        Post likers
      </DialogTitle>
      <DialogContent>
        {list.map((item, i) => (
          <Typography key={i} variant='body1' gutterBottom>
            &bull; {' ' + item.name}
          </Typography>
        ))}
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(LikersList)
